import PlayerStore from "@/store/player";
import {UserSource} from "@/store/player/types";
import ShopStore from "@/store/shop";
import {RewardedAdvType} from "@/store/shop/types";
import {Scene} from "phaser";
import {Settings} from "@/constants/settings";

export default class RewardedUtils {

    public static watchRewarded(scene: Scene, rewardedAdvType: RewardedAdvType, onComplete: () => unknown) {
        ShopStore.startWatchRewarded(rewardedAdvType).then(() => {
            if (PlayerStore.getPlayer().userSource === UserSource.ya) {

                // @ts-ignore
                window.ysdk.adv.showRewardedVideo({
                    callbacks: {
                        onOpen: () => {
                            RewardedUtils.setMute(scene, false);
                            console.log('Video ad open.');
                        },
                        onRewarded: () => {
                            RewardedUtils.setMute(scene, true);
                            onComplete();
                        },
                        onClose: () => {
                            RewardedUtils.setMute(scene, true);
                            console.log('Video ad closed.');
                        },
                        onError: (e: any) => {
                            RewardedUtils.setMute(scene, true);
                            console.log('Error while open video ad:', e);
                        }
                    }
                });
            } else {
                onComplete();
            }
        });
    }

    private static setMute(scene: Scene, mute: boolean) {
        if (mute) {
            scene.game.sound.mute = false;
        } else if (Settings.MUSIC_LOADED) {
            scene.game.sound.mute = true;
        }
    }
}